module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "treeview",
    class: {
      active: _vm.treeviewDisp
    }
  }, [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.toggleTreeview(_vm.module)
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.moduleObj.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.moduleObj.name[_vm.nowLang]))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    class: {
      'menu menu-open': _vm.currModule == _vm.module
    }
  }, [_vm._l((_vm.moduleObj.codapp), function(menus, menutype) {
    return [(menutype != 'dashboard') ? [(menus.length > 0 && true) ? [_c('li', {
      staticClass: "treeview submenu-header"
    }, [_c('div', {
      staticClass: "label-submenu-header"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.fontIcon[menutype]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.menu[menutype][_vm.nowLang]))])])]), _vm._v(" "), _vm._l((menus), function(codapp, key) {
      return [(true) ? [_c('li', {
        staticClass: "border-color-skin",
        class: {
          active: _vm.currCodapp == codapp
        },
        staticStyle: {
          "border-left": "1px solid"
        }
      }, [(_vm.$router.match(codapp).name !== '404') ? [_c('router-link', {
        attrs: {
          "to": {
            name: codapp
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.closeSidebarMobile()
          }
        }
      }, [_c('i', {
        staticClass: "codapp-icon fa",
        class: {
          'fa-circle': _vm.currCodapp == codapp, 'fa-circle-o': _vm.currCodapp != codapp
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "codapp-text"
      }, [_vm._v(_vm._s(_vm.descCodapp(_vm.moduleObj, codapp)))])])] : _vm._e()], 2)] : _vm._e()]
    })] : _vm._e()] : [(_vm.version >= '2.0.0' || _vm.moduleObj.type == 'mss') ? [(_vm.moduleObj.codapp_permis) ? [_c('li', {
      staticClass: "submenu-header header-dashboard",
      class: {
        active: _vm.currModule == _vm.module
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.module
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSidebarMobile()
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.fontIcon[menutype]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.menu[menutype][_vm.nowLang]))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star text-white pull-right icon-hover"
    })])], 1)] : _vm._e()] : _vm._e()]]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04d5af03!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/DashSidebarMenu.vue
// module id = 3513
// module chunks = 1